export var getCartTotal = function (items, coupon, shippingFee) {
    var total = 0;
    items.forEach(function (item) { return total += item.getTotal(); });
    if (shippingFee) {
        total += shippingFee;
    }
    if (coupon && coupon.discount_amount > 0) {
        total -= coupon.discount_amount;
    }
    return Math.max(0, total);
};
